import getRugbyView     from './rugby/getAppView'
import getCricketView   from './cricket/getAppView'
import getCricketViewLite from './cricket/getAppViewLite'

/**
 * Compose the Game package view
 * based on sport and page type
 * TODO: Add logic for other sports
 * 
 * @param  {String} options.pageType PageType
 * @param  {Object} options.state    Game package state
 * @return {Object}                  App view
 */
const composeView = ({
  pageType  = 'game',
  state     = {},
  params    = {},
  query     = {},
  isAppLite = false
}) => {

  let view
  const args = {
    pageType : pageType,
    state : state,
    params,
    query
  }

  switch( params.sport ) {
    case 'cricket':
      if (isAppLite) {      
        view = getCricketViewLite(args)
      } else {
        view = getCricketView(args)
      }
      break
    case 'rugby-league':
    case 'rugby':
      view = getRugbyView({
        pageType : pageType,
        state : state,
        params,
        query
      })
      break
  }

  return view
}

export default composeView



// WEBPACK FOOTER //
// ../app/components/gamepackage/composeView.js